const persistence = {
  get: key => localStorage.getItem(key),
  set: (key, value) => localStorage.setItem(key, value),
  delete: key => localStorage.removeItem(key),
}

export default persistence
